import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductTransactions20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_905)'>
      <path d='M7.5 6.75V8.25H12.5V6.75H7.5Z' fill='currentColor' />
      <path d='M7.5 5.25V3.75H12.5V5.25H7.5Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.25 10C0.25 15.3848 4.61522 19.75 10 19.75C15.3848 19.75 19.75 15.3848 19.75 10C19.75 4.61522 15.3848 0.25 10 0.25C4.68393 0.25 0.25 4.60422 0.25 10ZM5.75 2.92749C6.99128 2.17998 8.44543 1.75 10 1.75C11.5546 1.75 13.0087 2.17998 14.25 2.92749V12.6754L10.6431 10.5112C10.2473 10.2737 9.75273 10.2737 9.35688 10.5112L5.75 12.6754V2.92749ZM4.25 4.08391V13.1169C4.25 14.0885 5.30997 14.6887 6.14312 14.1888L10 11.8746L13.8569 14.1888C14.69 14.6887 15.75 14.0885 15.75 13.1169V4.08391C17.292 5.58291 18.25 7.67958 18.25 10C18.25 14.5563 14.5563 18.25 10 18.25C5.44365 18.25 1.75 14.5563 1.75 10C1.75 7.67958 2.70797 5.58291 4.25 4.08391Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_905'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductTransactions20.displayName = 'ProductTransactions20';
export default ProductTransactions20;
